/**
 * SimApp — 시뮬앱 루트. 로그인 게이트 → 디바이스 선택 → 3D 시뮬 모달.
 *
 * 세션 핸드오프: URL `?ticket=` 가 있으면 메인앱이 발급한 1회용 티켓을 교환해 동일 사용자로
 * 자동 로그인한다(메인앱 SNS/생체 계정과 신원 일치). 교환 후 URL 에서 ticket 제거.
 */
import { useEffect, useState } from 'react'
import { message } from 'antd'
import { isLoggedIn, simExchange } from './sim/api'
import { loadLabels, getLocale } from './framework/useLabel'
import LoginPage from './LoginPage'
import DevicePicker from './DevicePicker'
import DeviceDetailModal from './sim/DeviceDetailModal'

// URL 쿼리에서 핸드오프 티켓 추출(한 번만).
const initialTicket = (() => {
  try {
    return new URLSearchParams(window.location.search).get('ticket')
  } catch {
    return null
  }
})()

export default function SimApp() {
  const [authed, setAuthed] = useState(isLoggedIn())
  const [deviceCode, setDeviceCode] = useState<string | null>(null)
  const [exchanging, setExchanging] = useState(!!initialTicket)

  // 인증 완료 후 백엔드 라벨 번들 1회 로드(JWT 자동 부착). 실패해도 fallback 으로 동작.
  useEffect(() => {
    if (authed) void loadLabels(getLocale())
  }, [authed])

  useEffect(() => {
    if (!initialTicket) return
    // URL 에서 ticket 즉시 제거(노출/재실행 방지).
    try {
      const u = new URL(window.location.href)
      u.searchParams.delete('ticket')
      window.history.replaceState({}, '', u.toString())
    } catch { /* noop */ }
    simExchange(initialTicket)
      .then(() => { setAuthed(true); message.success('메인앱 계정으로 로그인되었습니다') /* SIM_MSG_MAINAPP_LOGIN_OK */ })
      .catch((e) => message.error('티켓 로그인 실패: ' + (e?.message ?? e)) /* SIM_MSG_TICKET_LOGIN_FAIL */)
      .finally(() => setExchanging(false))
  }, [])

  if (!authed) return <LoginPage onLoggedIn={() => setAuthed(true)} exchanging={exchanging} />

  return (
    <div style={{ minHeight: '100vh', background: '#f4f3f8' }}>
      <DevicePicker onOpen={setDeviceCode} />
      <DeviceDetailModal
        open={deviceCode != null}
        deviceCode={deviceCode}
        onClose={() => setDeviceCode(null)}
      />
    </div>
  )
}
